import { render, staticRenderFns } from "./ninfruit.vue?vue&type=template&id=1f44efac"
import script from "./ninfruit.vue?vue&type=script&lang=js"
export * from "./ninfruit.vue?vue&type=script&lang=js"
import style0 from "./ninfruit.vue?vue&type=style&index=0&id=1f44efac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports